import { useQuery } from "@tanstack/react-query";
import { Link, useParams } from "@tanstack/react-router";
import { PageHeader } from "../../components/ui";
import { ErrorState } from "../../components/States";
import { EnterpriseOfferForm } from "./customerTabs";
import { staffApi, staffKeys } from "./api";
import "./staff.css";

export function StaffEnterprisePage() {
  const { org: orgId } = useParams({ strict: false }) as { org: string };
  const detail = useQuery({ queryKey: staffKeys.org(orgId), queryFn: () => staffApi.org(orgId) });
  const d = detail.data;
  return (
    <div className="cust-page">
      <PageHeader
        back={<Link className="btn ghost cust-back" to="/staff/orgs/$org" params={{ org: orgId }} search={{ tab: "billing" }} aria-label="Back to billing">←</Link>}
        title="Create Enterprise offer"
        subtitle={d ? `Price a one-year agreement for ${d.org.name}. The customer must approve and pay before their plan changes.` : undefined}
      />
      {detail.isPending ? (
        <div className="card form-card" aria-busy="true"><span className="skeleton" style={{ width: "60%", height: 24 }}>Loading</span></div>
      ) : detail.isError ? (
        <ErrorState error={detail.error} retry={() => void detail.refetch()} />
      ) : d?.enterpriseContract ? (
        <div className="banner info">{d.org.name} already has an active Enterprise agreement.</div>
      ) : d?.enterpriseOffer && d.enterpriseOffer.status !== "expired" ? (
        <div className="banner info">An Enterprise offer is already {d.enterpriseOffer.status === "awaiting_payment" ? "waiting for payment" : d.enterpriseOffer.status}.</div>
      ) : d ? (
        <EnterpriseOfferForm d={d} />
      ) : null}
    </div>
  );
}
